import cn from 'classnames';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import default_image from '../../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { Select } from '../../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../../components/Common/Input/ProviderList';
import { RETURN_STATE, TO_ENTRY } from '../../../../../constans';
import { formFullDate, getDate } from '../../../../../utils';
import ReturnStepperInput from '../../../ReturnsEntry/Line/ReturnSteppertInput';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';

const ReturnsLine = ({
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsMap = {},
  postingsPrint = {},
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  onChangeReturn = () => { },
  changeState = () => { },
  entriedProduct = {},
  providerProductsMap = {},
  addProductToEntry,
  mode,
  tab,
  isOwner = false,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const onChange = (productId, field, value) => {
    onChangeReturn(order.id, order.shop, productId, field, value);
  };

  const addToEntry = async (productId, value) => {
    await addProductToEntry({ returnId: order.id, productId, shop: order.shop, quantity: parseInt(value) });
  };

  return (
    <TableLine key={order.id}>
      <TableCell width={WIDTH_POSTING[0]} minWidth={WIDTH_POSTING[0]} style={{ overflow: 'hidden' }}>
        <Column>
          {order.posting_number}
          <TextGrey>{order.type === 'overage' ? '' : order.id}</TextGrey>
          <div style={{ color: '#011d83' }}>{`${order.sales_schema || '?'}: ${order.skladName || '?'} -> ${order.skladName_return || '?'
            }`}</div>
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} minWidth={WIDTH_POSTING[12]} center>
        {getDate(order.dates?.costumer_return)}
        <Row style={{ width: '100%' }}>
          {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
          {order.market === 'yandex' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'ozon' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'sber' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
          )}
        </Row>
      </TableCell>

      <TableCell width={WIDTH_POSTING[1]} minWidth={WIDTH_POSTING[1]}>
        <Column>
          {order.products.map((p, k) => {
            const data = map[p.offer_id] || {};
            const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
            const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
            return (
              <div key={k} className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(img)}
                    className={styles.preview}
                    src={img.length > 0 ? img[0] : undefined}
                  />
                </div>
                <Column>
                  <div className={styles.name}>
                    {order.type === 'overage' ? `${p.name}` : `${p.ordered_quantity} x ${p.name}  `}
                    <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                      {p.offer_id}
                    </div>
                  </div>
                  {scan_time && (
                    <div className={styles.scan_time}>
                      {scan_time} {p.scan_user && `(${p.scan_user})`}
                    </div>
                  )}
                </Column>
              </div>
            );
          })}
        </Column>
      </TableCell>

      {mode === 'REPORT' ? (
        <TableCell width={WIDTH_POSTING[12]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={k} className={styles.div_line}>
                <div className={styles.num}> {p.common_quantity || 0}</div>
              </Row>
            ))}
          </Column>
        </TableCell>
      ) : (
        <TableCell width={WIDTH_POSTING[10]} center={true}>
          <Column style={{ alignItems: 'center' }}>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={k} className={styles.div_line}>
                <div className={styles.num}> {p.common_quantity || 0}</div>

                {/*  <Input
                  value={p.real_quantity}
                  onChange={(v) => onChange(p._id, 'real_quantity', v)}
                  style={{ width: '40px' }}
                  readOnly={p.is_added}
                  center
                />
                <ButtonWithTooltip
                  tooltip="Добавить на склад"
                  onClick={() => addToEntry(p._id)}
                  style={{ marginLeft: '10px', padding: '10px', width: '50px' }}
                  type={TYPE_BUTTONS.WHITE}
                  disabled={
                    p.is_added || tab === 4 || (p.real_quantity !== p.common_quantity && p.diff?.status === undefined)
                  }
                >
                  <Icon src={img_house} width={30} />
                </ButtonWithTooltip> */}
              </Row>
            ))}
          </Column>
        </TableCell>
      )}
      <TableCell width={WIDTH_POSTING[13]} center={true}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <Row key={k} className={styles.div_line}>
              <ReturnStepperInput
                item={p}
                entryItem={{}}
                onChange={(v) => onChange(p._id, 'real_quantity', v)}
                addToEntry={addToEntry}
              />
            </Row>
          ))}
        </Column>
      </TableCell>
      {mode !== 'REPORT' && (
        <TableCell width={WIDTH_POSTING[7]} center={true}>
          <Column center>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={k} className={styles.div_line}>
                <Select
                  select={p.diff?.status}
                  list={['Брак', 'Пересорт', 'Просрочка', 'Подмена', 'Недовложение', 'Возврат не получили', 'Нет']}
                  style={{ fontSize: '16px' }}
                  width={'200px'}
                  //disabled={p.is_added || p.real_quantity === p.common_quantity}
                  onSelect={(v) => onChange(p._id, 'diffStatus', v === 'Нет' ? null : v)}
                />
              </Row>
            ))}
          </Column>
        </TableCell>
      )}

      <TableCell width={WIDTH_POSTING[4]} center={true}>
        {entriedProduct.entry_id ? (
          <>
            <Link to={TO_ENTRY(entriedProduct.entry_id)} className={styles.link}>
              <div
                className={cn(
                  styles.status,
                  order.state === 'new' && styles.process,
                  order.state === 'confirmed' && styles.sold,
                  order.state === 'partly' && styles.pickup,
                )}
              >
                {RETURN_STATE[order.state]}
                <TextGrey fontSize={10} style={{ marginTop: '-5px', fontSize: '12px' }}>
                  {formFullDate(entriedProduct.scan.date)}
                </TextGrey>
              </div>
            </Link>
          </>
        ) : (
          <div
            className={cn(
              styles.status,
              order.state === 'new' && styles.process,
              order.state === 'confirmed' && styles.sold,
              order.state === 'partly' && styles.pickup,
            )}
          >
            {RETURN_STATE[order.state]}
          </div>
        )}
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <ProviderList selectProviderId={map[p.offer_id]?.provider_id} disabled={true} />
            </div>
          ))}
        </Column>
      </TableCell>

      {!isOwner && (
        <>
          <TableCell width={WIDTH_POSTING[1]}>
            <Column>
              <Text>{order.return_info.reason}</Text>
            </Column>
          </TableCell>
        </>
      )}
      {isOwner && (
        <>
          <TableCell width={WIDTH_POSTING[4]} center={true}>
            {order.products.map((p, k) => {
              const price =
                postingsMap[order.posting_number]?.products.find((item) => item.offer_id === p.offer_id)?.price || '?';

              const purchase = providerProductsMap[p.provider_sku]?.purchase;
              return (
                <div key={k}>
                  {price} / {purchase}
                </div>
              );
            })}
          </TableCell>
          <TableCell width={WIDTH_POSTING[4]} center={true}>
            <div
              className={cn(
                styles.status,
                order.return_info.type === 'Невыкуп' && styles.sorted,
                order.return_info.type === 'Возврат' && styles.waiting,
              )}
            >
              {order.return_info.type}
            </div>
          </TableCell>
          <TableCell width={WIDTH_POSTING[4]} center={true}>
            <div
              className={cn(
                styles.status,
                order.return_info.status === 'В пути' && styles.process,
                order.return_info.status === 'Принят от покупателя' && styles.process,
                order.return_info.status === 'В пункте выдачи' && styles.waiting,
                order.return_info.status === 'Готов к выдаче' && styles.pickup,
                order.return_info.status === 'Получен' && styles.sold,
                order.return_info.status === 'Компенсирован' && styles.pickup,
                order.return_info.status === 'Привезёт курьер' && styles.sold,
                order.return_info.status === 'В процессе утилизации' && styles.canceled,
                order.return_info.status === 'Утилизирован' && styles.canceled,
              )}
            >
              {order.return_info.status}
            </div>
          </TableCell>
          <TableCell width={WIDTH_POSTING[1]}>
            <Column>
              <Text>{order.return_info.reason}</Text>
              <TextGrey fontSize={12}> {order.return_info.place}</TextGrey>
            </Column>
          </TableCell>
        </>
      )}

      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </TableLine>
  );
};

export default ReturnsLine;
